<template lang="pug">
.other-office-message-list-tab(v-cloak)
  .box-body
    .message-histories.d-flex.flex-row.flex-nowrap.align-items-stretch
      //- left side list
      .message-list.d-flex.flex-column
        .message-list-title
          span メッセージ履歴
        .message-content(ref="messageAreaElement")
          .message(v-for="(message, index) in messages" :class="{ 'pb-3': messages.length == index + 1 }").pt-3.pr-3.pl-3
            b-card(no-body)
              OtherOfficeMessage(:ref="`otherOfficeMessage_${index}`" v-model="messages[index]" :item="item" :mimeTypes="mimeTypes" :fileUploadLimit="fileUploadLimit"
                @onUpdateMessage="onUpdateMessage($event, index)" @onDeleteMessage="onDeleteMessage" @onUndoDeleteMessage="onUndoDeleteMessage" @download="download")
              
              b-list-group(flush)
                //- show replies
                b-list-group-item(v-if="0 < message.replyCount")
                  a.show-replies(v-if="message.showReplies == false" @click="toggleReplies(message)") 返信を表示（{{ message.replyCount }}件）
                  a.show-replies(v-else="message.showReplies == true" @click="toggleReplies(message)") 返信を非表示
                //- reply messages
                b-list-group-item(v-if="message.showReplies == true" v-for="(reply, replyIndex) in message.replies")
                  .ml-4
                    OtherOfficeReplyMessage(:ref="`otherOfficeMessageReplyInput_${index}_${replyIndex}`"
                      v-model="message.replies[replyIndex]" :message="message" :item="item" :mimeTypes="mimeTypes" :fileUploadLimit="fileUploadLimit"
                      @onUpdateReply="onUpdateReply($event, index, replyIndex)" @onDeleteReply="onDeleteReply" @onUndoDeleteReply="onUndoDeleteReply" @download="download")
                //- no replies
                b-list-group-item(v-if="message.replyCount < 1")
                  span 返信なし
                //- input reply
                b-list-group-item(v-if="message.deleteFlag == false")
                  OtherOfficeMessageReplyInput(:ref="`otherOfficeMessageReplyInput_${index}`" v-model="message.inputReply" :name="message.datetime"
                    :mimeTypes="mimeTypes" :fileUploadLimit="fileUploadLimit" @onReply="onReply($event, index)")

      //- right side reply content
      .new-message-content.d-flex.flex-column
        .message-list-title
          span 新規トピック入力欄
        .new-message-input.d-flex.flex-wrap.align-items-stretch.register-body
          .mt-2
          //- title and text
          FormInput(v-model="title" key-name="タイトル" name="title" placeholder="タイトル" type="text" :validation-rules="{ required: true, max: 100 }" 
            :styles="{ minWidth: '220px', width: '100%'}" :maxlength="100" required)
          FormTextarea(v-model="text" key-name="本文" name="text" placeholder="本文" :validation-rules="{ required: true, max: 1000 }" 
            :maxlength="1000" :styles="{ minWidth: '220px', width: '100%', minHeight: '160px' }" required)
          //- files
          .register-row
            .register-group(style="max-width:100%;")
              .register-key
                .left-side.d-flex
                  span.key-name 添付ファイル
                  HelpIcon(popoverId="attached-files-help-text" title="添付ファイルについて")
                    template(#text)
                      span 選択可能なファイルは、写真（jpeg、png）、Microsoftドキュメントファイル（doc、docx、xls、xlsx、ppt、pptx）、pdfです。
                      span 送信可能なファイルサイズはPDFは50MB未満、その他のファイルは10MB未満です。
                      br
                      span ファイルサイズが大きいと送信に時間がかかる場合があります。
              .register-value
                MultiFileSelecter(name="temp-files" :mimetypes="mimeTypes" :limit="_registerFilesLimit" :width="'100%'" :height="'32px'"
                  :showPreview="false" @input="inputFiles")
                .error-messages.text-break(v-for="error in errors.collect('tempfiles-errors')")
                  label.error-message {{ error }}
                  br
            .register-group(v-if="0 < files.length" style="max-width:100%; overflow:hidden;")
              DraggableFiles.draggable-files(v-model="files" @delete="onFileDelete" :item-width="'90%'")
          .buttons.d-flex.flex-wrap.justify-content-end.align-items-stretch.align-content-center.mr-2
            button.btn.reply-btn.mb-2(@click="onRegisterMessage") 送信

  //- loading modal
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref, Inject } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore } from "@/store/store";

import Setting from "../../../../public/setting.json";

import { FileUrl, OtherOfficeMessageGetModel, OtherOfficeMessagePatchModel, OtherOfficeMessagePostModel, UpdateType } from "@/commons/services/OtherOfficeMessages";
import OtherOfficeReplyMessagesService, {
  OtherOfficeReplyMessageGetModel,
  OtherOfficeReplyMessagePatchModel,
  OtherOfficeReplyMessagePostModel,
  UpdateType as ReplyUpdateType
} from "@/commons/services/OtherOfficeReplyMessages";
import OtherOfficeMessageFileService from "@/commons/services/OtherOfficeMessageFile";
import S3UrlService from "@/commons/services/S3Url";
import { FacilityGetModel } from "@/commons/services/Facilities";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import DraggableFiles from "@/pc/components/DraggableFiles.vue";
import DraggableFile from "@/commons/models/DraggableFile";

import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import { OtherOfficeConnectionTableItem } from "./OtherOfficeConnectionTable.vue";
import OtherOfficeMessage from "@/pc/containers/sendOtherOfficeMessages/OtherOfficeMessage.vue";
import OtherOfficeReplyMessage from "@/pc/containers/sendOtherOfficeMessages/OtherOfficeReplyMessage.vue";
import OtherOfficeMessageReplyInput from "@/pc/containers/sendOtherOfficeMessages/OtherOfficeMessageReplyInput.vue";

/**
 * ### 他事業所メッセージ詳細タブ
 */
@Component({
  components: {
    PageLoading,
    OtherOfficeMessage,
    OtherOfficeReplyMessage,
    OtherOfficeMessageReplyInput,
    FormInput,
    FormTextarea,
    MultiFileSelecter,
    DraggableFiles,
    HelpIcon
  },
  $_veeValidate: { validator: "new" }
})
export default class OtherOfficeMessageListTab extends Vue {
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** 他事業所連携返信メッセージサービス */
  @Inject("OtherOfficeReplyMessagesService") otherOfficeReplyMessagesService!: OtherOfficeReplyMessagesService;

  /** ユーザー名。ユーザー情報修正画面で更新されるので、storeのgetterから値を取得する */
  @Getter("getFacility") public facility!: FacilityGetModel;

  @Ref() messageAreaElement!: any;

  /** 他事業所連携 */
  @Prop()
  item!: OtherOfficeConnectionTableItem;
  /** メッセージ（投稿） */
  @Prop()
  messages!: Array<OtherOfficeMessageListTabMessage>;

  /** ファイル登録数上限 */
  readonly fileUploadLimit: number = 10;

  /** 添付許可Content-Typeリスト */
  readonly mimeTypes = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    // doc and docx
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    // xls and xlsx
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // ppt and pptx
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ];

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** タイトル */
  title: string = "";
  /** 本文 */
  text: string = "";

  /** PDFモーダルの表示可否 */
  showPdfModal: boolean = false;
  /** PDFモーダルで表示するPDFのURL */
  pdfUrl: string = "";

  /** 返信メッセージ添付ファイル */
  files: Array<DraggableFile> = [];
  /** 添付ファイルのPDFを変換するか否か */
  needConvertPdf: boolean = false;

  /** ### 登録可能なファイル数を返す */
  get _registerFilesLimit(): number {
    const limit: number = this.fileUploadLimit - this.files.length;
    return limit;
  }

  public resetRegisterTopicFiles(): void {
    this.files = [];
    return;
  }

  public resetUpdateTopicFiles(index: number): void {
    const _message = this.$refs[`otherOfficeMessage_${index}`] as Array<OtherOfficeMessage>;
    _message[0].resetUpdateTopicFiles();
    return;
  }

  public resetRegisterReplyFiles(index: number): void {
    if (!this.messages) {
      return;
    }
    const _message = this.$refs[`otherOfficeMessageReplyInput_${index}`] as Array<OtherOfficeMessageReplyInput>;
    _message[0].resetFiles();
    return;
  }

  public resetUpdateReplyFiles(index: number, replyIndex: number): void {
    const _message = this.$refs[`otherOfficeMessageReplyInput_${index}_${replyIndex}`] as Array<OtherOfficeReplyMessage>;
    _message[0].resetUpdateReplyFiles();
    return;
  }

  /**
   * ### 左側メッセージリストのスクロール位置を最下段に移動させる
   *
   * - 親コンポーネントから任意のタイミングで呼び出される
   * - BottomScrollディレクティブを使用すると、メッセージリストがDOM更新されるたびに最下段に移動してしまうので使えない
   */
  public bottomScroll(): void {
    this.messageAreaElement.scrollTop = this.messageAreaElement.scrollHeight;
    return;
  }

  /**
   * ### 子コンポーネントのメッセージ更新イベント
   *
   * - リクエスト情報を作成する
   * - 親コンポーネントに通知する
   */
  public onUpdateMessage(payload: { message: OtherOfficeMessageListTabMessage; input: { title: string; text: string; files: Array<File> } }, index: number): void {
    const requestBody: OtherOfficeMessagePatchModel = this.createUpdateMessageRequestBody(payload);
    this.$emit("onUpdateMessage", { message: payload.message, requestBody, files: payload.input.files, index });
    return;
  }

  public createUpdateMessageRequestBody(payload: { message: OtherOfficeMessageListTabMessage; input: { title: string; text: string } }): OtherOfficeMessagePatchModel {
    return {
      updateType: UpdateType.EDIT,
      title: payload.input.title,
      text: payload.input.text,
      fileUrls: [],
      updated: payload.message.updated
    };
  }

  public onDeleteMessage(message: OtherOfficeMessageListTabMessage): void {
    this.$emit("onDeleteMessage", message);
    return;
  }

  public onUndoDeleteMessage(message: OtherOfficeMessageListTabMessage): void {
    this.$emit("onUndoDeleteMessage", message);
    return;
  }

  public onUpdateReply(
    payload: { message: OtherOfficeMessageListTabMessage; reply: OtherOfficeMessageListTabMessageReply; input: { text: string; files: Array<File> } },
    index: number,
    replyIndex: number
  ): void {
    const requestBody: OtherOfficeReplyMessagePatchModel = this.createUpdateReplyRequestBody(payload);
    this.$emit("onUpdateReply", { message: payload.message, reply: payload.reply, requestBody, files: payload.input.files, index, replyIndex });
    return;
  }

  public createUpdateReplyRequestBody(payload: { reply: OtherOfficeMessageListTabMessageReply; input: { text: string } }): OtherOfficeReplyMessagePatchModel {
    return {
      updateType: ReplyUpdateType.EDIT,
      text: payload.input.text,
      fileUrls: [],
      updated: payload.reply.updated
    };
  }

  public onDeleteReply(payload: { deleteTargetMessage: OtherOfficeMessageListTabMessage; reply: OtherOfficeReplyMessageGetModel }): void {
    this.$emit("onDeleteReply", payload);
    return;
  }

  public onUndoDeleteReply(payload: { deleteTargetMessage: OtherOfficeMessageListTabMessage; reply: OtherOfficeReplyMessageGetModel }): void {
    this.$emit("onUndoDeleteReply", payload);
    return;
  }

  /**
   * ### 投稿者を取得する
   */
  public getSender(message: OtherOfficeMessageListTabMessage): string {
    if (!this.item) {
      return "";
    }
    if (message.senderFacilityId == this.item.registerdFacilityId) {
      return this.item.officeName;
    } else {
      return userStore.facility.name;
    }
  }

  /**
   * ### 日付数値を日付文字列に変換する
   */
  public convertSendDatetime(message: OtherOfficeMessageListTabMessage): string {
    if (!message) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(message.datetime, "yyyy/mm/dd hh:MM");
  }

  /**
   * ### ファイル入力イベント
   *
   * - ビジネスロジックを集約したサービスクラスにファイルを渡してバリデーションと追加処理を行う
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const service: OtherOfficeMessageFileService = new OtherOfficeMessageFileService(this.$validator, "tempfiles-errors");
    const addFiles: Array<File> = await service.createAddFile(files, this._registerFilesLimit, this.files.length);
    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);

      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    this.isBusy = false;
    return;
  }

  /**
   * ### ファイル削除イベント
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 投稿ボタン押下イベント
   */
  public async onRegisterMessage(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      const requestBody: OtherOfficeMessagePostModel = this.createRegisterMessageRequestBody();
      this.$emit("onRegisterMessage", { requestBody: requestBody, files: this.files });
    }
    return;
  }

  public createRegisterMessageRequestBody(): OtherOfficeMessagePostModel {
    return {
      title: this.title,
      text: this.text,
      fileUrls: []
    };
  }

  /**
   * ### ファイルのダウンロード
   */
  public async download(fileUrl: FileUrl): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const file: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, fileUrl.url, fileUrl.name);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file);
    link.download = fileUrl.name;
    link.click();

    this.isBusy = false;

    return;
  }

  /**
   * ### 返信の表示切り替え
   */
  public async toggleReplies(message: OtherOfficeMessageListTabMessage): Promise<void> {
    // 返信表示中であれば非表示にする
    if (message.showReplies == true) {
      message.showReplies = false;
    }
    // 返信非表示であれば表示にする
    // 表示にするタイミングで未取得の場合は取得も行う
    else {
      if (message.replies.length < 1) {
        this.isBusy = true;
        this.loadingMessage = "読込み中...";
        const replyMessages = await this.getOtherOfficeReplyMessages(message);
        message.replies = replyMessages;
        this.isBusy = false;
      }
      message.showReplies = true;
    }
    return;
  }

  public async getOtherOfficeReplyMessages(message: OtherOfficeMessageListTabMessage): Promise<Array<OtherOfficeMessageListTabMessageReply>> {
    const messages: Array<OtherOfficeReplyMessageGetModel> = await this.otherOfficeReplyMessagesService.gets(userStore, this.item.registerdFacilityId, message.datetime);
    const replies: Array<OtherOfficeMessageListTabMessageReply> = [];
    for (const message of messages) {
      replies.push({
        ...message,
        isEditing: false
      });
    }
    return replies;
  }

  /**
   * ### 返信ボタン押下イベント
   */
  public onReply(reply: { value: OtherOfficeMessageListTabMessageReplyInput; datetime: number }, index: number): void {
    const requestBody: OtherOfficeReplyMessagePostModel = this.createRegisterReplyRequestBody(reply.value);
    this.$emit("onRegisterReplyMessage", { requestBody: requestBody, files: reply.value.files, datetime: reply.datetime, index });
    return;
  }

  public createRegisterReplyRequestBody(reply: OtherOfficeMessageListTabMessageReplyInput): OtherOfficeReplyMessagePostModel {
    return {
      text: reply.text,
      fileUrls: []
    };
  }

  /**
   * ### 入力内容のリセット
   */
  public initialize(): void {
    this.title = "";
    this.text = "";
    this.files = [];
    return;
  }
}
export interface OtherOfficeMessageListTabMessage extends OtherOfficeMessageGetModel {
  /** 編集中か否か */
  isEditing: boolean;
  /** 返信の表示可否 */
  showReplies: boolean;
  /** 表示する返信 */
  replies: Array<OtherOfficeMessageListTabMessageReply>;
  /** 登録する返信情報 */
  inputReply: OtherOfficeMessageListTabMessageReplyInput;
}
export interface OtherOfficeMessageListTabMessageReply extends OtherOfficeReplyMessageGetModel {
  /** 編集中か否か */
  isEditing: boolean;
}
export interface OtherOfficeMessageListTabMessageReplyInput {
  /** 本文 */
  text: string;
  /** ファイル */
  files: Array<DraggableFile>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.other-office-message-list-tab {
  margin-left: auto;
  margin-right: auto;

  @mixin title() {
    background-color: $bg-header;
    padding: 5px;
    min-height: 32px;
    font-weight: bold;
    text-align: center;
  }

  .box {
    margin-bottom: 0;
  }

  .message-histories {
    // 外枠はここで描画させる
    border: solid 1px $border-darkgray;

    .message-list-title {
      @include title();
      border-bottom: solid 1px $border-lightgray;
      min-height: 35px;
    }

    // 左側、メッセージリスト
    .message-list {
      min-width: 60%;
      max-width: 60%;
      overflow-y: auto;
      overflow-x: auto;

      .message-content {
        overflow-y: scroll;
        overflow-x: auto;
        position: relative;
        max-height: calc(100vh - 265px);
        // 背景色
        background-color: $bg-message;
      }
    }
    // 右側、メッセージリスト
    .new-message-content {
      min-width: 40%;
      max-width: 40%;
      max-height: calc(100vh - 231px);
      overflow-y: auto;
      overflow-x: auto;
      border-left: solid 1px $border-darkgray;

      .new-message-input {
        width: 100%;
        .register-group {
          margin: 1rem !important;
        }
        .draggable-files {
          ::v-deep {
            .register-group {
              margin: 0 !important;
            }
          }
        }
      }
      .register-btn {
        width: 104px;
      }
    }
  }
}
</style>
